export const Panel = ({
  title,
  hint,
  action,
}: {
  title: string
  hint: string
  action: React.ReactNode
}) => (
  <section className="flex flex-wrap items-center justify-between gap-4 rounded-lg border bg-muted/30 p-6">
    <div>
      <h2 className="font-semibold text-lg">{title}</h2>
      <p className="text-muted-foreground text-sm">{hint}</p>
    </div>
    {action}
  </section>
)
